// components/advertiser-wallet/ModalShell.tsx
import React from "react";
import { X } from "lucide-react";

interface ModalShellProps {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
}

const ModalShell: React.FC<ModalShellProps> = ({ title, subtitle, onClose, children }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
    <div className="bg-white rounded-2xl w-full max-w-md p-5 sm:p-6 relative max-h-[90vh] overflow-y-auto">
      <button
        onClick={onClose}
        className="absolute top-4 right-4 sm:top-5 sm:right-5 w-7 h-7 rounded-full bg-gray-100 flex items-center justify-center text-gray-500 hover:bg-gray-200"
        aria-label="Close"
      >
        <X size={16} />
      </button>
      <h3 className="text-lg font-semibold text-black">{title}</h3>
      {subtitle && <p className="text-sm text-blue-600 mt-0.5">{subtitle}</p>}
      <div className="mt-5">{children}</div>
    </div>
  </div>
);

export default ModalShell;